import React from 'react'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function ConfirmDialog({ t, title, description, confirmText, cancelText, danger = true, loading, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-[5000] bg-black bg-opacity-30 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white relative p-6 md:p-8 w-11/12 max-w-sm max-h-[90vh] overflow-y-auto rounded-2xl text-center" onClick={(event) => event.stopPropagation()}>
        <h3 className="text-lg font-bold text-dark-blue mb-2">{title}</h3>
        <p className="text-sm text-secondary mb-6">{description}</p>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 h-11 rounded-full border border-border-lines text-dark-blue font-medium"
          >
            {cancelText ?? t('misc.cancel')}
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 h-11 rounded-full text-white font-medium disabled:opacity-50 ${danger ? 'bg-danger' : 'bg-primary'}`}
          >
            {confirmText ?? t('misc.continue')}
          </button>
        </div>
      </div>
    </div>
  )
})
